import {useNavigate} from 'react-router-dom';
import {SoopMobilePopup, SoopScrim} from '@soop-ui/soop-ui';
import {ROUTE} from '@/constants/main/route';
import styles from './CloseLayer.module.scss';

interface CloseLayerProps {
  closeLayer: () => void;
}

const CloseLayer = ({closeLayer}: CloseLayerProps) => {
  const navigate = useNavigate();

  const closeChatbot = () => {
    if (window.opener) {
      window.close();
    } else {
      // 챗봇 페이지로 직접 접근한 경우 고객센터 홈으로 이동
      navigate(ROUTE.HELP.INDEX);
    }
  };

  return (
    <SoopScrim className={styles.dim}>
      <SoopMobilePopup noTitle>
        <SoopMobilePopup.Content>
          <div>숲덕이를 종료 하시겠습니까?</div>
        </SoopMobilePopup.Content>
        <SoopMobilePopup.Footer
          primaryLabel='확인'
          secondaryLabel='취소'
          onPrimaryClick={closeChatbot}
          onSecondaryClick={closeLayer}
        />
      </SoopMobilePopup>
    </SoopScrim>
  );
};

export default CloseLayer;
